import React, { Fragment, useState } from 'react';
import {
  SimpleForm,
  Toolbar,
  SaveButton,
  required,
  useNotify,
  minLength,
} from 'react-admin';
import { useDataProvider } from 'react-admin';
import { QRCodeSVG } from 'qrcode.react';
import QrcodeIcon from '@mui/icons-material/QrCode';
import { Box, Typography } from '@mui/material';
import { PhoneInput } from '../../components';

const CustomToolbar = props => {
  return (
    <Toolbar {...props}>
      <SaveButton disabled={props.invalid} label="Gerar qrcode" icon={<QrcodeIcon />} />
    </Toolbar>
  )
};

const containerSx = {
  display: 'flex',
  marginTop: '30px',
  padding: '20px',
};

const qrcodeImageContainerSx = {
  minWidth: 200,
};

const GenerateConfirmationQrcode = () => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const [qrcodeInfo, setQrcodeInfo] = useState<{ deviceUniqueId: string; signupCode?: string | null } | null>(null);

  const executeSearch = async ({ cellphone }: any) => {
    try {
      const response = await dataProvider.create('chains/chainId/customers/confirmation/generate-qrcode', { data: { cellphone: cellphone.slice(2) } })
      setQrcodeInfo(response.data);
    } catch (error: any) {
      notify(error?.message || 'Não foi possível gerar o qrCode', { type: 'warning' });
    }
  };

  return (
    <Fragment>
      <SimpleForm toolbar={<CustomToolbar />} onSubmit={executeSearch}>
        <PhoneInput source="cellphone" label="Telefone" validate={[required(), minLength(13)]} />
      </SimpleForm>
      {qrcodeInfo && (
        <Box sx={containerSx}>
          <Box sx={qrcodeImageContainerSx}>
            <Typography variant="h6" textAlign="center" sx={{ fontWeight: '600' }} gutterBottom>Qrcode de confirmação</Typography>
            <QRCodeSVG
              value={qrcodeInfo.deviceUniqueId}
              bgColor="#ffffff"
              fgColor="#000000"
              size={256}
            />
            {qrcodeInfo.signupCode && (
              <Box
                sx={{
                  marginTop: '24px',
                  padding: '16px',
                  borderRadius: '8px',
                  border: '1px solid #e0e0e0',
                  backgroundColor: '#f5f9f5',
                  textAlign: 'center',
                }}
              >
                <Typography variant="caption" sx={{ color: '#666', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
                  Código do cliente
                </Typography>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 700,
                    color: '#2e7d32',
                    letterSpacing: '6px',
                    fontFamily: 'monospace',
                    marginTop: '4px',
                  }}
                >
                  {qrcodeInfo.signupCode}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      )}
    </Fragment>
  );
};

export default GenerateConfirmationQrcode;
